import { StatTile, StatTileEmpty } from '@/components/ui/stat-tile';
import { translate } from '../../../../utils/Common';

// plataforma más utilizada
const MostUsedPlatform = ({ cantPackagesPickUp }) => {
    if (cantPackagesPickUp === null) return <StatTile loading />;

    if (!cantPackagesPickUp?.length) {
        return <StatTileEmpty label={translate("dashboard.home.platforms_most_use.dont_package")} />;
    }

    const mostUsed = [...cantPackagesPickUp].sort((a, b) => a.value - b.value).at(-1)?.name;

    return (
        <StatTile
            value={mostUsed}
            label={translate("dashboard.home.platforms_most_use")}
            info={translate("dashboard.home.platforms_most_use.info")}
        />
    );
};

export default MostUsedPlatform;
